import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CircularProgress } from '@pec/aion-ui-components/components/CircularProgress';
import { Error } from '@pec/aion-ui-components/components/Error';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: theme.spacing(2)
    },
    title: {
      fontSize: 20,
      lineHeight: '24px',
      fontWeight: theme.typography.fontWeightMedium,
      letterSpacing: 0.15,
      color: '#1B1B1B',
      marginBottom: theme.spacing(1)
    }
  })
);

type Props = {
  isFetching?: boolean;
  hasFetchingError?: boolean;
  title: string;
  children: React.ReactNode;
};

export const Widget: React.FC<Props> = ({ isFetching, hasFetchingError, title, children }) => {
  const classes = useStyles();
  const { t } = useTranslation('subscriber');

  return (
    <Paper classes={{ root: classes.container }}>
      <Typography variant="h6" classes={{ root: classes.title }}>
        {title}
      </Typography>
      {isFetching ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : null}
      {hasFetchingError ? (
        <Error message={t('common.errorProcessingRequest', 'There was an error processing your request.')} />
      ) : null}
      {!isFetching && !hasFetchingError ? children : null}
    </Paper>
  );
};
